module.exports = __webpack_public_path__ + "img/bg.131c13c3.jpg";